export enum StormDoorHandleType {
    Indeterminate = 0,
    Generic = 1,
    LarsonQuickFit = 2,
}

